import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { CreateProjectVM, ICreateProjectsComponent } from './CreateProjectVM';
import { useHistory } from 'react-router-dom';
import stores from 'cd-eft/models/Stores';
// Styles
import USWDS from 'uswds/src/js/components';
import { Input } from 'cd-eft/components/common/Input/Input';
import { SelectOption } from 'cd-eft/components/common/SelectOption/SelectOption';
import { ComboBox } from 'cd-eft/components/common/ComboBox/ComboBox';
import './createProject.scss';
import { InformationModal } from 'cd-eft/components/common/InformationModal/InformationModal'; 
import { InformElementModal } from 'cd-eft/components/common/InformationModal/InformElementModal'; 

const libraryStore = stores.AppStore.projectsLibraryStore;
const { comboBox } = USWDS;

const noRainfallStates = ['OR', 'WY', 'ID', 'WA', 'MT'];

const CreateProjectsComponent = (props: ICreateProjectsComponent) => {
  const history = useHistory();
  const vm = useRef(new CreateProjectVM(props, history)).current;
  const { projectClassId } = vm.createProjectForm;

  useEffect(() => {
    comboBox.on();
    const els = document.getElementsByClassName('usa-combo-box');
    for (const el of els) {
      el.getElementsByTagName('input')[0].setAttribute('autocomplete', 'nope');
    }
    vm.getStates();

    return () => {
      comboBox.off();
      if (history.location.pathname !== '/projects/new-project') {
        libraryStore.pojectionByLocationData = [];
      }
    };
  }, []);

  useEffect(() => {
    if (
      vm.selectedValues.coordinateSystemType /* &&
      vm.selectedValues.state &&
      vm.selectedValues.county */
    ) {
      vm.projectionByLocation();
    }
  }, [
    vm.selectedValues.coordinateSystemType,
    /*     vm.selectedValues.state,
        vm.selectedValues.county, */
    vm.createProjectForm.state,
    vm.createProjectForm.county,
  ]);

  return (
    <div className="padding-3">
      <div className="create-project-container">
        <div className="padding-3">
          <h1>Create Project</h1>
          <h2 >Enter a project title, type and client to create a new project</h2>
          <div className="form-cp">
            <div className="grid-row grid-gap">
              <div className="mobile-lg:grid-col-4 bdf-column no-asterisk">
                <Input
                  label="Project Name"
                  idAndName="projectTitle"
                  type="text"
                  value={vm.createProjectForm.projectTitle}
                  onChange={vm.handleInputChange}
                  required={true}
                  errorMsg={vm.formValidation.formErrors.projectTitle}
                  valid={vm.formValidation.projectTitleValid}
                  className={vm.errorClass('projectTitle')}
                />
              </div>

              <div className="mobile-lg:grid-col-4 bdf-column no-asterisk">
                <Input
                  label="Client"
                  idAndName="client"
                  type="text"
                  value={vm.createProjectForm.client}
                  onChange={vm.handleInputChange}
                  required={true}
                  errorMsg={vm.formValidation.formErrors.client}
                  valid={vm.formValidation.clientValid}
                  className={vm.errorClass('client')}
                />
              </div>
              <div className="mobile-lg:grid-col-4 bdf-column">
                <Input
                  label="Practice (optional)"
                  idAndName="practice"
                  type="text"
                  value={vm.createProjectForm.practice}
                  onChange={vm.handleInputChange}
                  required={false}
                  errorMsg={''}
                  valid={true}
                />
              </div>
              <div className="mobile-lg:grid-col-4 bdf-column">
                <SelectOption
                  label="Project Type"
                  idAndName="projectClassId"
                  options={vm.allowedProjectTypes}
                  value={projectClassId}
                  onChange={vm.handleProjectClassIdChange}
                  required={true}
                  valid={vm.formValidation.projectClassIdValid}
                  errorMsg={vm.formValidation.formErrors.projectClassId}
                  className={vm.errorClass('projectClassId')}
                />
              </div>

              <div className="mobile-lg:grid-col-4 bdf-column">
                {vm.usStates.length > 0 && (
                  <SelectOption
                    label="State"
                    idAndName="state"
                    options={vm.usStates.map((el) => ({
                      name: el.state_name!,
                      value: el.state_code!,
                    }))}
                    value={vm.createProjectForm.state}
                    onChange={vm.handleStateInputChange}
                    required={true}
                    errorMsg={vm.formValidation.formErrors.state}
                    valid={vm.formValidation.stateValid}
                    className={vm.errorClass('state')}
                  />
                )}
              </div>

              <div className="mobile-lg:grid-col-4 bdf-column">
                <SelectOption
                  label="County"
                  idAndName="county"
                  options={vm.counties.length > 0 ? vm.counties.map((el) => ({
                    name: el.county_name!,
                    value: el.county_name!,
                  })) : []}
                  value={vm.createProjectForm.county}
                  onChange={vm.handleInputChange}
                  required={true}
                  errorMsg={vm.formValidation.formErrors.county}
                  valid={vm.formValidation.countyValid}
                  className={vm.errorClass('county')}
                />
              </div>
              {/* Coordinate System Type */}
              <div className="mobile-lg:grid-col-4 bdf-column">
                <SelectOption
                  label={`${vm.createProjectForm.projectClassId !== 1 ? "Coordinate System Type" : "Coordinate System Type (optional)"} `}
                  idAndName="coordinateSystemType"
                  options={vm.coordinateSystemOptions}
                  value={vm.selectedValues.coordinateSystemType}
                  onChange={(event: any) => vm.handleCoordinateSystemChange(event.target.value)}
                  required={true}
                  helpIcon={true}
                  helpIconCallback={vm.toggleHelpModal}
                  valid={vm.formValidation.coordinateSystemTypeValid}
                  errorMsg={`${vm.createProjectForm.projectClassId === 4 ? vm.formValidation.formErrors.coordinateSystemType : ''}`}
                  className={`${vm.createProjectForm.projectClassId === 4 ? vm.errorClass('coordinateSystemType') : "bdf-input"} `}
                />
              </div>
              {/* Units */}
              <div className="mobile-lg:grid-col-2 bdf-column">
                <label className="usa-label" htmlFor="unit">
                  Unit
                </label>
                <input
                  className="form-control-plaintext px-2 capitalize unit-input"
                  id="unit"
                  aria-label="Unit"
                  name="unit"
                  type="text"
                  value={vm.createProjectForm.projectClassId === 4 ? 'Meter' : vm.createProjectForm.projectClassId === 1 ? 'Feet' : ''}
                  readOnly
                />
              </div>
              {/* Zone */}
              {libraryStore.pojectionByLocationData.length === 1 || libraryStore.pojectionByLocationData.length === 0 ? (
                <div className="mobile-lg:grid-col-2 bdf-column">
                  <label className="usa-label" htmlFor="zone">
                    Zone
                  </label>
                  <input
                    className="form-control-plaintext px-2 capitalize unit-input"
                    id="zone"
                    aria-label="Zone"
                    name="zone"
                    type="text"
                    value={libraryStore.pojectionByLocationData.length === 1 ? libraryStore.pojectionByLocationData[0].zoneName : ''}
                    readOnly
                  />
                </div>
              ) : (
                <div className="mobile-lg:grid-col-2 bdf-column">
                  <SelectOption
                    label="Zone"
                    idAndName="zone"
                    options={libraryStore.pojectionByLocationData.map((data) => ({ name: data.zoneName, value: data.zoneName }))}
                    value={vm.selectedZone || ''}
                    onChange={vm.handleZoneNameInputChange}
                    required={false}
                    className={vm.errorClass('zone')}
                    errorMsg={vm.formValidation.formErrors.zone}
                    valid={true}
                  />
                </div>
              )}
              {/* Projection Name */}
              <div className="mobile-lg:grid-col-4 bdf-column">
                <label className="usa-label" htmlFor="projectionName">
                  Projection Name
                </label>
                <textarea
                  className="form-control-plaintext px-2 capitalize projection-name"
                  id="projectionName"
                  aria-label="Projection Name"
                  name="projectionName"
                  readOnly
                  value={
                    libraryStore.pojectionByLocationData.length === 1 && libraryStore.pojectionByLocationData[0].zoneName
                      ? `${vm.selectedValues.coordinateSystemType} Zone ${libraryStore.pojectionByLocationData[0].zoneName} ${vm.createProjectForm.projectClassId === 4 ? 'Meter' : vm.createProjectForm.projectClassId === 1 ? 'Ft_Intl' : ''}`
                      : libraryStore.pojectionByLocationData.length > 1 && vm.selectedZone
                        ? `${vm.selectedValues.coordinateSystemType} Zone ${vm.selectedZone} ${vm.createProjectForm.projectClassId === 4 ? 'Meter' : vm.createProjectForm.projectClassId === 1 ? 'Ft_Intl' : ''}`
                        : ''
                  }
                />
              </div>
              <div className="mobile-lg:grid-col-12">
                <button
                  onClick={async () => {
                    const isNoRainfall = vm.isHydrologyNoRainfallState();
                    if (isNoRainfall) {
                      await vm.showNoRainfallWarning();
                    } else {
                      vm.handleSubmit2();
                    }
                  }}
                  className="usa-button float-right mt-5"
                  disabled={vm.disableCreateProject}
                >
                  {projectClassId === 4 ? 'Proceed to Create Hydrology' : 'Proceed to Create Surface'}
                </button>
              </div>
            </div>
          </div>
        </div>
        <InformElementModal 
          showHelpModal={vm.showHelpModal} 
          helpModalContent={<CoordinateSystemDetails />}
          helpModalTitle={vm.helpModalTitle} 
          closeHelpModal={vm.toggleHelpModal}
        />
      </div>
    </div>
  );
};

export const CreateProject = observer(CreateProjectsComponent);

export const CoordinateSystemDetails = (props: {className?: string}) => {
  return(
      <div className={props.className ? props.className : ''} tabIndex={0}>
          <p>
              The <strong>NAD83 (2011) UTM</strong> projection with units in <strong>International Feet</strong> refers to a 
              spatial reference system that combines the North American Datum of 1983 (2011 adjustment), Universal Transverse 
              Mercator (UTM) coordinate system, and International Feet as the unit of measurement. This system is widely used for 
              accurate mapping and geospatial data across North America, utilizing the UTM's zone-based Transverse Mercator projection 
              for minimizing distortion over specific regions, with coordinates expressed in International Feet.
          </p>
          <p>
              The <strong>WGS 1984 UTM</strong> (World Geodetic System 1984 Universal Transverse Mercator) projection is a global 
              coordinate system used for mapping and navigation. It divides the world into a series of longitudinal zones, each covering 
              a 6-degree band of longitude. Each zone uses a Transverse Mercator projection to minimize distortion in the region it covers. 
              The coordinates are measured in <strong>meters</strong>, providing high accuracy for local and regional mapping. This system is ideal 
              for detailed land mapping, especially in large-scale engineering, construction, and GIS applications. 
          </p>
      </div>
  ); 
}; 
